/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
// import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// // core components
// import Admin from "layouts/Admin.js";
// import RTL from "layouts/RTL.js";
// import AutomatonProvider from "../src/context/automatonContext";
// import LoadingProvider from "../src/context/loadingContext";

// import UserProvider from "../src/context/userContext";
import "assets/css/material-dashboard-react.css?v=1.10.0";
import App from "../src/App";
import UserProvider from "../src/context/userContext";
import AlertProvider from "../src/context/Feedback/alertContext";
import SystemProvider from "../src/context/systemContext";
ReactDOM.render(
  <UserProvider>
    <SystemProvider>
      <AlertProvider>
        <App />
      </AlertProvider>
    </SystemProvider>
  </UserProvider>,
  document.getElementById("root")
);
